const Badge = ({ text = '', fontColor = '#000000', bgColor = '#ffffff', smaller = false, onClick = () => null }) => {
    return (
        <div onClick={onClick} className={`badge ${smaller ? 'smaller' : ''}`} style={{ backgroundColor: bgColor, color: fontColor }}>
            {text}
        </div>
    );
};

export default Badge;
